import React from "react";
import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";
import { getResolvedChecklistHeadingContent } from "../../JobShiftPreStart/jobShiftPreStartUtils";

const EMPTY_ROWS = ["sign-off-1", "sign-off-2", "sign-off-3"];

export default function PreStartSignOffPreview({ preStartChecklist }) {
  const signOffHeadingContent = getResolvedChecklistHeadingContent(preStartChecklist, "prestart_staff_signoff") || "";
  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`}>4</span>
        Pre-Start Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewEditableHeading}>
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: signOffHeadingContent }} />
        </div>
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {EMPTY_ROWS.map((rowKey) => (
              <tr key={rowKey}>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}